/* --------------------------------------------------------------------------------------
   privacyStatements.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const privacyStatementEnComponent = {
  template: require("./privacyStatement/privacy_en.html"),
};

export const privacyStatementCaComponent = {
  template: require("./privacyStatement/privacy_ca.html"),
};

export const privacyStatementCsComponent = {
  template: require("./privacyStatement/privacy_cs.html"),
};

export const privacyStatementEsComponent = {
  template: require("./privacyStatement/privacy_es.html"),
};



// WEBPACK FOOTER //
// ./src/app/components/privacyStatements.component.js